import React from 'react';
import Switch from '@material-ui/core/Switch';
import { createStyles, withStyles } from '@material-ui/core/styles';

const ThemeSwitch = withStyles((theme) =>
  createStyles({
    root: {
      width: '51px',
      height: '31px',
      padding: 0,
      margin: '0 16px',
    },
    switchBase: {
      padding: '1px',
      color: theme.palette.background.paper,
      '&$checked': {
        transform: 'translateX(20px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: theme.palette.primary.main,
          opacity: 1,
          border: 'none',
        },
      },
    },
    thumb: {
      width: '24px',
      height: '24px',
      margin: '2px',

      position: 'relative',
      '&:after': {
        content: theme.palette.type === 'dark' ? '""' : '',
        position: 'absolute',
        height: '24px',
        width: '24px',
        borderRadius: '16px',
        top: 0,
        left: 11,
        backgroundColor: theme.palette.primary.contrastText,
      },
    },
    track: {
      borderRadius: '16px',
      opacity: 1,
    },
    checked: {},
  }),
)(Switch);

export default ThemeSwitch;
